export default __webpack_public_path__ + "static/media/bilalpic.16112a8f.jpg";